export default function MySQL_STR_TO_DATE() {
  return (
    <div>
      <h2>MySQL_STR_TO_DATE</h2>    </div>
  );
}